import { get, post } from "../GenericServices";

const ServiceRate = {
  getData: (querystring) => {
    return get(`service-rate?${querystring}`);
  },
  getDetails: (id, querystring) => {
    return get(`service-rate/${id}?${querystring}`);
  },
  saveEditServiceRates: (data) => {
    return post(`service-rate`, data);
  },
  getLastStatus: () => {
    return get(`import-planning/status`);
  },
};

export default ServiceRate;
